import React from 'react';
import propTypes from 'prop-types';
import { DatePicker, InputGroup } from 'rsuite';
import { isBefore, isSameDay } from 'date-fns';
import 'rsuite/dist/rsuite.min.css';

const processStart = start => new Date(new Date(start).setHours(0, 0, 0, 0));
const processEnd = end => new Date(new Date(end).setHours(23, 59, 59, 0));

export function UiDateRangePicker({ start, end, onChange }) {
  const [lastStart, setLastStart] = React.useState(start);
  const [lastEnd, setLastEnd] = React.useState(end);

  const handleChange = (start, end) => {
    const timeDidChange =
      isSameDay(start, lastStart) && isSameDay(end, lastEnd);
    setLastStart(start);
    setLastEnd(end);

    /* eslint no-unused-expressions: ["error", { "allowTernary": true }] */
    /* if user did not change time process start/end ensures default start:12:00:00 am end: 11:59:59 pm */
    timeDidChange
      ? onChange(start, end)
      : onChange(processStart(start), processEnd(end));
  };
  return (
    <InputGroup className="ui-date-range-picker-group">
      <DatePicker
        className="ui-date-range-picker"
        format="yyyy-MM-dd"
        value={start}
        onChange={start => handleChange(start, end)}
        cleanable={false}
        onSelect={start => handleChange(start, end)}
      />
      <InputGroup.Addon>~</InputGroup.Addon>
      <DatePicker
        className="ui-date-time-range-picker"
        format="yyyy-MM-dd"
        value={end}
        onChange={end => handleChange(start, end)}
        onSelect={end => handleChange(start, end)}
        cleanable={false}
        disabledDate={date => isBefore(date, start)}
      />
    </InputGroup>
  );
}

UiDateRangePicker.propTypes = {
  start: propTypes.instanceOf(Date).isRequired,
  end: propTypes.instanceOf(Date).isRequired,
  onChange: propTypes.func,
};

UiDateRangePicker.defaultProps = {
  onChange: () => {},
};
